/**
 * ns.wow Notes
 * Facade class for public accessible core functionality.
 */


class Plugin {


  init() {

		// Handling for popup window.
		// If disabled, the links will redirect to the category page (for ContentParsers) or to the article with the note (ForwardParser).

		if (NSContext.plugins.notes.openInPopup) {

			// Add popup box to show the linked notes

			document.body.insertAdjacentHTML( 'beforeend',
				`<div class="nhsnote-box">
			    <div class="nhsnote-box__background js-nhsnote-box-close"></div>
			    <div class="nhsnote-box__inner js-nhsnote-box-inner">
				    <button class="nhsnote-box__close js-nhsnote-box-close"></button>
				    <div class="nhsnote-box__content js-nhsnote-box-content"></div>
			    </div>
		    </div>` );

			// Click event for opening the popup box

			const linkElements = document.querySelectorAll("." + NSContext.plugins.notes.noteLinkClass);

			linkElements.forEach( (element) => {
					element.addEventListener("click", (event) => {
						event.preventDefault();
						this.openPopup(event.target);
						return false;
					});
				}
			);

			// Click event for closing the popup box (2 Events, close button (X) and background around dialog)

			const popupBoxClose = document.querySelectorAll('.js-nhsnote-box-close')

			popupBoxClose.forEach( (element) => {
					element.addEventListener("click", (event) => {
						this.closePopup( event.target);
					});
				}
			);

		}

  }


  getNoteId(string) {
    let output = '';
    output = string.replace(".", "\\.");
    // Remove brackets
    output = output.replace("(", "");
    output = output.replace(")", "");
    output = output.replace("{", "");
    output = output.replace("}", "");
    output = output.replace("[", "");
    output = output.replace("]", "");
    // Remove leading zeros
    output = output.replace(/^0+/, "");
    return output;
  }


  openPopup(element) {

    const popupBox = document.querySelector('.nhsnote-box');
    const popupInner = popupBox.querySelector('.js-nhsnote-box-inner');
    const popupContent = popupBox.querySelector('.js-nhsnote-box-content');

    popupBox.style.display = 'block';

    fetch(element.getAttribute('data-href'),
      {
        method: 'GET',
        headers: {'X-WP-Token': NSContext.token},
      })
      .then( (response) => {
        return response.json();
      })
      .then( (data) => {
        let html = '';
        // Check for WP error
        if (data.hasOwnProperty('code')) {
          if (data.code == 'rest_missing_access_token' || data.code == 'rest_invalid_access_token') {
            html += '<h2 class="nhsnote__debug_title">' + NSContext.plugins.notes.texts.reload + '</h2>';
          } else {
            html += '<h2 class="nhsnote__debug_title">' + NSContext.plugins.notes.texts.notfound + '</h2>';
            html += '<p class="nhsnote__debug_hint">' + NSContext.plugins.notes.texts.hint + '</p>';
          }
        } else {
          html = data.content;
        }
        popupBox.classList.add('nhsnote-box--loaded');
        popupContent.innerHTML = html;

				// Follow links in popup window (reload the current popup content)
				let popupLinks = popupContent.querySelectorAll('.' + NSContext.plugins.notes.noteLinkClass);
				popupLinks.forEach((element) => {
						element.addEventListener('click', (event) => {
							if (event.target.hasAttribute('data-href')) {
								let url = event.target.getAttribute('data-href');
								this.reloadPopup(popupContent, url);
							}
						});
					}
				);

				// Run script tags in loaded HTML
				if (NSContext.plugins.notes.execScripts == true) {
					let scripts = [...popupContent.querySelectorAll('script')];
					scripts.forEach((script) => {
						try {
							let newScriptElement = document.createElement('script');
							let attributes = [...script.attributes];
							attributes.forEach((attribute) => {
								newScriptElement.setAttribute(attribute.name, attribute.value)
							});
							newScriptElement.type = 'text/javascript';
							let scriptContent = document.createTextNode(script.innerHTML);
							newScriptElement.appendChild(scriptContent);
							script.parentNode.replaceChild(newScriptElement, script);
						} catch (error) {
							console.error(error);
						}
					});
				}
        popupInner.style.display = 'block';
        document.dispatchEvent(new Event('noteLoaded'));
        window.dispatchEvent(new Event('resize'));
        document.querySelector('body').classList.add('notes-open');
				popupContent.scrollTop = 0;
      })
      .catch(function (err) {
        console.warn('Error fetching note', err);
      });
  }

	reloadPopup(popupContent, url) {
		fetch(url,
			{
				method: 'GET',
				headers: {'X-WP-Token': NSContext.token},
			})
			.then((response) => {
				return response.json();
			})
			.then( (data) => {
				let content = '';
				// Check for WP error
				if (data.hasOwnProperty('code')) {
					if (data.code == 'rest_missing_access_token' || data.code == 'rest_invalid_access_token') {
						content += '<h2 class="nhsnote__debug_title">' + NSContext.plugins.notes.texts.reload + '</h2>';
					} else {
						content += '<h2 class="nhsnote__debug_title">' + NSContext.plugins.notes.texts.notfound + '</h2>';
						content += '<p class="nhsnote__debug_hint">' + NSContext.plugins.notes.texts.hint + '</p>';
					}
				} else {
					content = data.content;
				}
				popupContent.innerHTML = content;
				popupContent.scrollTop = 0;
			})
			.catch(function (err) {
				console.warn('Error fetching note', err);
			});
	}


  closePopup(element) {

    const popupBox = document.querySelector('.nhsnote-box');
    const popupInner = popupBox.querySelector('.js-nhsnote-box-inner');
    const popupContent = popupBox.querySelector('.js-nhsnote-box-content');

    document.querySelector('body').classList.remove('notes-open');

    popupContent.innerHTML = "";
    popupBox.classList.remove('nhsnote-box--loaded');
    popupInner.style.display = "none";
    popupBox.style.display = "none";

    document.dispatchEvent(new Event("noteClosed"));

  }


}

export default new Plugin();
